import axios from "axios";

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 5000,
});

// export const warpcastApi = axios.create({
//   baseURL: "https://pro.itscashless.com/api/profile",
//   headers: {
//     "Content-Type": "application/json",
//   },
// });
